import { createError } from './helpers/createError';

export const UnexpectedError = createError('UnexpectedError');
